import React from 'react'

import styles from './index.module.css';

const RadioButton = ({
  name,
  radioValue,
  label,
  wrapperClassName = '',
  onChange,
  ...props
}) => {
  return (
    <div className={wrapperClassName} >
      <label className={styles.label}>
        <input
          type="radio"
          name={name}
          className={styles.input}
          value={radioValue}
          checked={props.input.value === radioValue}
          onChange={() => props.input.onChange(radioValue)}
          {...props}
        />
        &nbsp;<span className="p_basic">{label}</span>
        <span className={styles.checkmark} />
      </label>
    </div>
  );
};

export default RadioButton;
